import React from 'react';
import { motion } from 'framer-motion';
import HomeBanner from '../images/HomeBanner.jpg';
import './NewBanner.css';

const NewBanner = () => {
  return (
    <section className="new-banner-section">
      <div className="new-banner-container">
        <img
          src={HomeBanner}
          alt="Udhaar Portal - Instant Personal Loans"
          className="new-banner-image"
        />
        <div className="new-banner-overlay">
          <div className="new-banner-content">
            <motion.h1
              className="new-banner-title"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <span className="new-title-part-1">Instant Cash</span>
              <span className="new-title-part-2">Infinite Potential</span>
            </motion.h1>
            
            <motion.p
              className="new-banner-subtitle"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              Borrow up to ₹1 lakh with ease, whenever life demands extra support.
              Our instant personal loans cover medical emergencies, travel, shopping, vehicles, and more.
            </motion.p>

            <motion.div
              className="new-banner-buttons"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
            >
              <motion.button
                className="new-btn-primary"
                onClick={() => window.location.href = "/apply-now"}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Apply Now
              </motion.button>

              <motion.button
                className="new-btn-secondary"
                onClick={() => window.location.href = "/about-us"}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Learn More
              </motion.button>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewBanner;
